// extracted by mini-css-extract-plugin
module.exports = {"root":"PatientQuestionnaire_root__GioKT","header":"PatientQuestionnaire_header__Du_qw","info":"PatientQuestionnaire_info__3tsae"};